import { EmailOutlined } from '@mui/icons-material';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import { Avatar, Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { EditIcon } from '../../../../../shared/components/Icons';
import { ERole } from '../../../../../shared/enums/user/ERole';
import { ETheme } from '../../../../../shared/enums/user/ETheme';
import { getUserInitials } from '../../../../../shared/functions/getUserInitials';
import { IUser } from '../../../../../shared/interfaces/user/IUser';
import { darkPalette, lightPalette } from '../../../../../shared/mui/palettes';
import { RootState } from '../../../../../store/store';

interface IProps {
  user: IUser;
}
const EmployeePreviewHeader = ({ user }: IProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    theme,
    role,
    id: userId,
  } = useSelector((state: RootState) => state.auth.userData) as IUser;
  return (
    <Box
      sx={{
        borderBottom: `1px solid ${theme === ETheme.LIGHT ? lightPalette.primary.light : darkPalette.background.light}`,
        paddingBottom: '20px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <Avatar
          style={{ marginRight: '8px' }}
          sx={{ height: '120px', width: '120px', borderRadius: '10px' }}
          src={user?.profilePhoto?.thumbnail}
          variant="square"
        >
          {getUserInitials(user)}
        </Avatar>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '120px',
            width: '100%',
          }}
        >
          <Typography variant="h5" fontWeight={'bold'}>
            {user?.displayName}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              alignItems: { xs: 'flex-start', lg: 'center' },
              justifyContent: 'space-between',
              flexDirection: { xs: 'column', lg: 'row' },
            }}
          >
            <Box
              sx={{
                paddingY: { xs: '10px', lg: 'none' },
                display: { xs: 'none', lg: 'block' },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <WorkOutlineOutlinedIcon />
                <Typography variant={'body2'} sx={{ ml: '5px' }}>
                  {user?.position ?? '-'}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <EmailOutlined />
                <Typography variant={'body2'} sx={{ ml: '5px' }}>
                  {user?.email ?? '-'}
                </Typography>
              </Box>
            </Box>
            {(role !== ERole.USER || user?.id === userId) && (
              <Button
                variant={'contained'}
                onClick={() =>
                  navigate(
                    `/${role === ERole.USER ? 'user' : 'admin'}/employee/${user?.id}/1`,
                  )
                }
                sx={{ width: 'auto' }}
              >
                <EditIcon fill={lightPalette.primary.light} />
                {t('general.edit')}
              </Button>
            )}
          </Box>
        </Box>
      </div>
    </Box>
  );
};

export default EmployeePreviewHeader;
